function masonry_layout() {

  jQuery('.off_grid').removeClass('off_grid'),
  jQuery('.testimonials > .cols > .col').css('marginTop', 0);

  var ele = jQuery('.testimonials > .cols > .col > blockquote'),
      no_cols = 0,
      row_no = 0,
      control_offset = 0,
      control_width = 0,
      new_row_ele_pos = 0,
      item_heights = [],
      row_heights = [];

  ele.each( function(i) {
    // console.log('element no ' + i);
    var pos = jQuery(this).offset(),
        width = jQuery(this).outerWidth(),
        height = jQuery(this).outerHeight(),
        nudge = 0;

    item_heights.push(height);

    if( i == 0 ) {
      control_width = width;
      new_row_ele_pos = pos.left;
    } else if( width > control_width ) {
      jQuery(this).closest('.col').addClass('off_grid');
    }
    if( pos.left > control_offset ) {
      no_cols++;
      control_offset = pos.left;
    }
    if( i !== 0 && pos.left == new_row_ele_pos ) {
      row_no++;
    }
    if( row_heights[row_no] === undefined || height > row_heights[row_no] ) {
      row_heights[row_no] = height;
    }
    // console.log({row_no});
    if( row_no > 1 ) {
      jQuery(this).closest('.col').addClass('off_grid');
    } else if( row_no > 0 ) {
      var items_above_height = item_heights[i - (no_cols)],
          rows_above_height = row_heights[row_no - 1];
      nudge = -(rows_above_height - items_above_height);
      jQuery(this).closest('.col').css('marginTop', nudge + 'px');
    }
  });

}
jQuery( document ).ready(function() {
  masonry_layout();
});
jQuery( window ).on('resize', function() {
  masonry_layout();
});
